import React, { useEffect, useState } from "react";
import { Button, Grid2, Container, Typography, Paper } from "@mui/material";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import handleAxiosError from "../../components/ErrorHandler";
import { notifErr } from "../../components/Functions";
import { Loading } from "../../components/Loading";
import { getFetcher } from "../../components/Fetchers";
import { AppUserDTO } from "../../model/entity/AppUserDTO";

const Account = () => {
  const navigate = useNavigate();
  const [appUserDTO, setAppUserDTO] = useState<AppUserDTO | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/auth/me`
        );
        setAppUserDTO(response.data);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
    };

    fetchData();
  }, []);

  if (appUserDTO === null) return <Loading />;

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: "1.5rem" }}>
        <Typography variant="h5" sx={{ marginBottom: "1.5rem" }}>
          Osobní údaje
        </Typography>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography>
              Celé jméno: <br /> <b>{appUserDTO.fullName}</b>
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography>
              Email: <br /> <b>{appUserDTO.email}</b>
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography>
              Datum registrace: <br />
              <b>{dayjs(appUserDTO.createdAt).format("DD.MM.YYYY HH:mm:ss")}</b>
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography>
              Naposledy přihlášen: <br />
              <b>{dayjs(appUserDTO.lastLogin).format("DD.MM.YYYY HH:mm:ss")}</b>
            </Typography>
          </Grid2>
        </Grid2>

        <Grid2
          size={{ xs: 12 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: "2rem",
            gap: "1rem",
          }}
        >
          <Button
            className="editBtn"
            variant="outlined"
            onClick={() => navigate("/account/change-password")}
          >
            Změnit heslo
          </Button>
        </Grid2>
      </Paper>
    </Container>
  );
};

export default Account;
